import { RouteRecordRaw } from 'vue-router'
import Appointment from '@/views/Appointment.vue'
import profileRoutes from './profile'
import buyCourseRoutes from './buycouse'
import pointRedeemCampaignRoutes from './pointredeemcampaign'
import AuthLayout from './layout/AuthLayout.vue'

declare module 'vue-router' {
  interface RouteMeta {
    showFooter?: boolean
  }
}

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: AuthLayout,
    meta: {
      showFooter: true,
    },
    children: [
      {
        path: 'appointment',
        name: 'Appointment',
        component: Appointment, // instantly load Appointment component
      },
      ...profileRoutes,
      ...buyCourseRoutes,
      ...pointRedeemCampaignRoutes,
    ],
  },
]
export default authRoutes
